import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography } from "@mui/material";
import { logout } from "../../store/slices/authSlice";

const ProtectedRoute = ({ isAuthenticated }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, consentRequired, loading: authLoading } = useSelector((state) => state.auth);

  const role = user?.role?.slug || user?.role;
  const isStudent = String(role || "").toLowerCase() === "student";

  useEffect(() => {
    if (isAuthenticated && isStudent) {
      localStorage.setItem(
        "logoutReason",
        "Student access is restricted to the MyAMS Mobile App. Please download the app on Android or iOS to access your account."
      );
      dispatch(logout());
    }
  }, [isAuthenticated, isStudent, dispatch]);

  if (isStudent) {
    return <Navigate to="/login" replace />;
  }

  // Wait for checkAuth to finish so refresh on deep links does not mis-route before session is restored.
  if (authLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
        }}
      >
        <Typography color="text.secondary">Loading…</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (consentRequired && location.pathname !== "/consent" && location.pathname !== "/welcome") {
    return <Navigate to="/consent" replace />;
  }

  if (!consentRequired && location.pathname === "/consent") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
